module.exports = "<div>\n  <button class=\"btn btn-default\" (click)=\"sellOn('kijiji')\">\n    Sell on kijiji\n  </button>\n  <button class=\"btn btn-default\" (click)=\"sellOn('subito')\">\n    Sell on subito\n  </button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/fonzi-module/sell-buttons/sell-buttons.component.html
// module id = 750
// module chunks = 1